import { Box, Popover, Text } from '@wix/design-system';
import React from 'react';
export const EllipsisTooltipWrapper = ({ children, fullText, hasEllipsis, }) => {
    const [isTooltipDisplayed, setIsTooltipDisplayed] = React.useState(false);
    return hasEllipsis ? (React.createElement(Popover, { theme: "light", placement: "top", showArrow: true, shown: isTooltipDisplayed, appendTo: "window", moveBy: { x: 0, y: 3 }, dataHook: "ellipsis-tooltip-wrapper", onMouseEnter: () => setIsTooltipDisplayed(true), onMouseLeave: () => setIsTooltipDisplayed(false) },
        React.createElement(Popover.Element, null, children),
        React.createElement(Popover.Content, null,
            React.createElement(Box, { padding: "5px 14px", dataHook: "ellipsis-tooltip-content" },
                React.createElement(Text, null, fullText))))) : (React.createElement(React.Fragment, null, children));
};
//# sourceMappingURL=EllipsisTooltipWrapper.js.map